<template>
  <div class="footer-container">
    <div class="tb">
      <div class="tb-span"></div>
      <!-- <div class="s7-top">
        <div class="s7-content">
          <div class="s7t-con">
             <img src="../../assets/images/ic1.png" alt="">
             <div class="s7t-con-r">
               <v-countup :start-value="start" :end-value="end[0]" :duration="duration"></v-countup>
               <p>CUSTOMERS(+)</p>
             </div>
          </div>
          <div class="s7t-con">
             <img src="../../assets/images/ic2.png" alt="">
             <div class="s7t-con-r">
               <v-countup :start-value="start" :end-value="end[1]" :duration="duration"></v-countup>
               <p>CLOUD COMPUTING(GB)</p>
             </div>
          </div>
          <div class="s7t-con">
             <img src="../../assets/images/ic3.png" alt="">
             <div class="s7t-con-r">
               <v-countup :start-value="start" :end-value="end[2]" :duration="duration"></v-countup>
               <p>SUCCESS RATE(%)</p>
             </div>
          </div>
          <div class="s7t-con">
             <img src="../../assets/images/ic4.png" alt="">
             <div class="s7t-con-r">
               <v-countup :start-value="start" :end-value="end[3]" :duration="duration"></v-countup>
               <p>PROJECTS DONE</p>
             </div>
          </div>
        </div>
      </div> -->
      <div class="s7t-all">
        <!-- <div class="s7t-middle">
          <h3>合作伙伴</h3>
          <div class="sub-middle">
            <div class="mid-con" v-for="(item, index) in mids">
              <img :src="item.src" alt="">
            </div>
          </div>
        </div> -->
        <div class="s7t-bottom">
          <div class="bot-con">
            <router-link :to="{path: '/about.html'}">
              <h5>关于我们</h5>
            </router-link>
            <p v-for="(item, index) in s7list[0].list">
              <router-link :to="guanyu(index)">
                <span>{{item.title}}</span>
              </router-link>
            </p>
          </div>
          <div class="bot-con">
            <router-link :to="{path: '/products.html'}">
              <h5>产品服务</h5>
            </router-link>
              <p v-for="(item, index) in s7list[1].list">
                <router-link :to="todevelop(index)">
                  <span>{{item}}</span>
                </router-link>
              </p>
          </div>
          <div class="bot-con3">
            <router-link :to="{path: '/application.html'}">
              <h5>行业应用</h5>
            </router-link>
            <p v-for="(item, index) in s7list[2].list">
              <router-link :to="{name: 'article',params: {
                id: item.id + '.html',
                ch: 31
              }}">
                <span>{{item.title}}</span>
              </router-link>
            </p>
          </div>
          <div class="bot-con bo">
            <h5 style="opacity: 0;">s</h5>
            <p v-for="(item, index) in s7list[3].list">
              <router-link :to="{name: 'article',params: {
                id: item.id + '.html',
                ch: 31
              }}">
                <span>{{item.title}}</span>
              </router-link>
            </p>
          </div>
          <div class="bot-con bo bo1">
            <router-link :to="art(0)">
              <h5>新闻中心</h5>
            </router-link>
            <p v-for="(item, index) in s7list[4].list">
              <router-link :to="art(index)">
                <span>{{item}}</span>
              </router-link>
            </p>
          </div>
          <div class="bot-con2">
            <h5><img src="../../assets/images/wechat.png" alt="">微信公众号</h5>
            <img src="../../assets/images/erweima.png" alt="" class="wechat">
          </div>
        </div>
      </div>
    </div>
    <div class="s7-footer">
      <p class="mob">版权所有：湖北中天亿信科技股份有限公司</p> <p>Copyright © 2006-2025 ZTYS.COM.CN</p><p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<img src="../../assets/images/police.png" alt="">&nbsp;鄂ICP备11017564号-2 </p><p>增值电信业务经营许可证编号：鄂B1、B2-20100045</p>
    </div>
  </div>
</template>


<script>
  import { news } from '../../api/index.js'
  export default {
     data(){
       return {
         start: 0,
         duration: 2,
         end: [1000, 1048576, 98, 6781],
         mids: [{
           src: require("../../assets/img/icon12.png")
         },{
           src: require("../../assets/img/icon1.png")
         },{
           src: require("../../assets/img/icon8.png")
         },{
           src: require("../../assets/img/icon11.png")
         },{
           src: require("../../assets/img/icon5.png")
         },{
           src: require("../../assets/img/icon10.png")
         }],
         s7list: [{
           list: [{
             title: "公司简介",
             id: "110",
             ch: "37"
           },{
             title: "领导致辞",
             id: "117",
             ch: "38"
           },{
             title: "企业文化",
             id: "111",
             ch: "39"
           },{
             title: "加入我们"
           }]
         },{
           list: ["互联网定制开发","大数据应用服务","智慧城市"]
         },{
           list: [{
			 title: "亿信云平台",
             id: 203           
           },{
             title: "知识图谱平台",
             id: 200
           },{
             title: "融合通信平台",
             id: 201
           },{
		     title: "应急指挥调度平台",
             id: 206
           },{
             title: "新零售系统",
             id: 207
           }]
         },{
           list: [{
			 title: "政务大数据共享交换平台",
             id: 199 
           },{
		     title: "智慧校园管理系统",
             id: 204
           },{
             title: "供应链管理系统",
             id: 205
           },{
			 title: "网站（集群）内容管理系统",
             id: 202 
           },{
             title: "实验室管理系统",
             id: 208
           }]
         },{
           list: ["公司动态","行业热点","公示公告"]
         }]
       }
     },
     created() {
        // news({
        //   apikey: 123456,
        //   channel: 31,
        //   page: 1,
        //   pagesize: 10
        // }).then(res => {
        //   console.log(res.data)
        //   this.s7list[2].list = res.data[0]
        //   this.s7list[2].list.reverse()
        // })
     },
     methods: {
       todevelop(index){
         if(index == 0){
           return {
             path: '/develop.html',
           }
         }else if(index == 1){
           return {
             path: '/bigdata.html',
           }
         }else if(index == 2){
           return {
             path: '/city.html',
           }
         }
       },
       guanyu(index){
         if(index == 0){
           return{name: 'article', params: {
             id: 110 + '.html',
             ch: 37
           }}
         }else if(index == 1){
           return{name: 'article', params: {
             id: 117 + '.html',
             ch: 37
           }}
         }else if(index == 2){
           return{path: '/about.html'}
         }else if(index == 3){
           return{path: '/personnel.html'}
         }
       },
       art(index){
         if(index == 0){
           return{
             name: 'content',
             params: {
               ch: 24,
               page: '1.html'
             }
           }
         }else if(index == 1){
           return{
             name: 'content',
             params: {
               ch: 25,
               page: '1.html'
             }
           }
         }else if(index == 2){
           return{
             name: 'content',
             params: {
               ch: 26,
               page: '1.html'
             }
           }
         }
       },
     }
  }
</script>

<style scoped>
  .footer-container{position: relative; padding-bottom: 30px; background-size: cover;}
  .s7-content{width: 1480px; margin: auto; display: flex;}
  .s7-top{width: 100%; margin: auto; padding: 80px 0 80px 0; background: url(../../assets/images/footbg1.png) top center;}
  .s7t-con{width: 25%; text-align: center;}
  .s7-top *,.s7t-middle *,.s7t-bottom *{position: relative; z-index: 10;}
  .tb{position: relative;}
  .tb-span{position: absolute; width: 100%; height: 100%; background-color: #0d162e; opacity: .8;}
  .s7t-all{padding-bottom: 60px; background: url(../../assets/images/footbg2.png) center center;}
  .s7t-middle h3{text-align: center; color: #d0d4f5; font-size: 30px; line-height: 130px; font-weight: normal;}
  .s7t-middle{width: 1470px; margin: auto;}
  .sub-middle{width: 100%; display: flex; flex-wrap: wrap;}
  .mid-con{width: 16.6%; height: 68px;}
  .mid-con img{display: block; position: relative; top: 50%; left: 50%; transform: translate(-50%, -50%); transition: all .5s ease-in-out;}
  .mid-con img:hover{ filter: drop-shadow(0 0 10px #000) brightness(200%);}
  .s7t-bottom{width: 1400px; padding-top: 80px; margin: auto; display: flex; color: #fff;}
  .bot-con{flex: 1; box-sizing: border-box;}
  .bot-con3{flex: .8;}
  .bot-con2{flex: .6;}
  .bot-con2 h5 img{position: relative;top: 2px; padding: 0 10px 0 0;}
  .bot-con h5,.bot-con2 h5,.bot-con3 h5{font-size: 16px; cursor: pointer;}
  .bot-con p,.bot-con3 p,.bot-con2 p{font-size: 14px; padding-top: 10px; color: #999999}
  .bot-con p span,.bot-con3 p span,.bot-con2 p span{cursor: pointer;}
  .p1{font-size: 16px !important;}
  .ewm{padding-top: 10px;}
  .s7t-con span{font-size: 48px; color: #fff;}
  .s7t-con img{display: inline-block; vertical-align: middle;}
  .s7t-con-r{display: inline-block; vertical-align: middle; padding-left: 10px; text-align: center;}
  .s7t-con-r p{font-size: 16px; color: #fff;}
  .s7-footer{position: absolute; bottom: 0; width: 100%; line-height: 32px; font-size: 12px; text-align: center; color: #989898; background: #333333;}
  .s7-footer *{display: inline-block; vertical-align: middle;}
  .wechat{width: 109px; padding-top: 10px;}
  .bot-con3-m{display: none;}
  .s7t-bottom h5{color: #fff;}
  .s7t-bottom p span:hover{color: #fff;}
  .s7t-bottom p span{cursor: pointer; color: #989898;}

  @media screen and (max-height: 860px){
    .s7t-middle{padding-top: 10px;}
    .s7t-bottom{padding-top: 10px;}
  }

  @media screen and (max-width: 1280px){
    .s7t-con img{width: 60px;}
    .s7t-con-r span{font-size: 28px;}
    .s7t-con-r p{font-size: 14px;}
    .s7t-middle h3{font-size: 26px; line-height: 60px;}
    .s7t-middle{width: 90% !important;}
  }

  @media screen and (max-width: 1440px){
    .s7t-middle{padding-top: 30px;}
    .s7t-bottom{padding-top: 30px;}
  }

  @media screen and (max-width: 1560px){
    .s7t-con span{font-size: 30px;}
    .s7t-middle{width: 1200px;}
    .s7t-bottom{width: 1200px;}
    .bot-con6{flex: 5;}
    .s7-content{width: 1200px;}
  }

  @media screen and (min-width: 1025px) and (max-width: 1200px) {
    .s7-content{width: 100%}
    .s7-top{width: 100%;}
    .s7t-con{width: 25%;}
    .s7t-con span{font-size: 30px;}
    .bot-con6{flex: 5;}
    .s7t-bottom{width: 100%;}
  }

  @media screen and (min-width: 769px) and (max-width: 1024px) {
    .s7-content{width: 100%}
    .s7-top{width: 100%;}
    .s7t-con{width: 25%;}
    .s7t-con img{display: none;}
    .s7t-con span{font-size: 30px;}
    .mid-con{width: 33.33%;}
    .bot-con {padding: 0;}
    .bot-con:nth-child(1),.bot-con:nth-child(4){flex: .8;}
    .s7t-bottom{width: 94%; box-sizing: border-box;}
  }

  @media screen and (max-width: 768px) {
    .footer-container{padding: 0;}
    .mid-con:nth-child(n+5){display: none;}
    .mid-con{width: 25%;}
    .mid-con img{width: 80%;}
    .s7-top{display: none;}
    .sub-middle{display: flex; width: 100%;}
    .s7t-middle{width: 100% !important;}
    .s7t-middle h3{font-size: 20px;}
    .s7t-bottom{width: 100%; padding-left: 6%; box-sizing: border-box;}
    .s7t-bottom h5{font-weight: normal; font-size: 14px;}
    .s7t-bottom .bo{display: none;}
    .s7t-bottom .bot-con2{display: none;}
    .s7-footer{position: relative;}
    .bot-con p{font-size: 12px;}
    .bot-con:nth-child(1){flex: .8;}
    .bot-con3-m{display: block;}
    .bot-con3 p{font-size: 12px;  margin: 0; padding-top: 10px;}
    .bot-con3 p:last-child{display: none;}
    .bot-con3{flex: 1.8;}
    .mob{display: none;}

    .s7-footer{line-height: 22px; padding: 10px 0 10px 0;}
  }

</style>



// WEBPACK FOOTER //
// src/components/public/footer.vue